import { connect } from 'react-redux'
import compose from 'recompose/compose'
import withHandlers from 'recompose/withHandlers'
import { bindActionCreators } from 'redux'

import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as PlaybookActions from 'app/modules/playbook/actions'

import Keyword from './component'

const mapStateToProps = (state, props) => ({
  keyword: PlaybookSelectors.getKeyword(state, props),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      deleteKeyword: PlaybookActions.deleteKeyword,
      setKeywordText: PlaybookActions.setKeywordText,
      setKeywordType: PlaybookActions.setKeywordType,
    },
    dispatch,
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onDeleteClick: props => () => props.actions.deleteKeyword(props.id),
    onTextChange: props => event => {
      props.actions.setKeywordText({
        keywordId: props.id,
        text: event.target.value,
      })
    },
    onTypeChange: props => ({ value: type }) => {
      props.actions.setKeywordType({
        keywordId: props.id,
        type,
      })
    },
  }),
)(Keyword)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/Keyword/index.js